import { useEffect, useRef } from "react";
import LoopLine from "../LoopLine";
import decorationLine from "assets/landing/about-decor-line.svg";
import { useAnimation, useInView } from "framer-motion";
import { motion } from "framer-motion";
import { FormatUsersUnderline1 } from "assets/icons/FormatUsersUnderline1";
import { FormatUsersUnderline2 } from "assets/icons/FormatUsersUnderline2";
import { FormatUsersUnderline3 } from "assets/icons/FormatUsersUnderline3";

const LandingAbout = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  // Parent container for stagger
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  // Child animations
  const fadeUpVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
      className="relative pb-[10.285vw] max-lg:pb-[34vw]"
    >
      <div className="max-lg:px-[6.4vw] px-[5.05vw] flex flex-col gap-[2.571vw] max-lg:gap-[6.4vw]">
        <motion.h2
          className="text-gradient max-lg:text-[8.56vw] font-luxora-medium relative z-20 leading-[1.1] font-[400] text-[64px]"
          variants={fadeUpVariants}
        >
          Mini App Format That Brings Users Back
        </motion.h2>

        <motion.div
          className="flex flex-col gap-[1.714vw] lg:max-w-[52.14vw]"
          variants={fadeUpVariants}
        >
          <motion.p
            className="text-black leading-[1.1] font-normal leading-[110%] text-24 max-lg:text-[4.27vw]"
            variants={fadeUpVariants}
          >
            Mini apps have already proven their scale and retention power. With
            over{" "}
            <div className="inline relative z-0">
              <div className="inline relative z-10 font-[600]">500M people</div>{" "}
              <FormatUsersUnderline1
                className="absolute bottom-[-5%] max-lg:w-[25.53vw] max-lg:h-auto
               w-[11.53vw] h-[0.97vw] z-[-2] left-1/2 -translate-x-1/2"
              />
            </div>{" "}
            <div className="inline relative z-10"> already</div> using them,
            more than{" "}
            <div className="inline relative z-0">
              <div className="inline relative z-10 font-[600]">75K apps </div>{" "}
              <FormatUsersUnderline2 className="absolute bottom-[-5%] z-[-2] max-lg:w-[17.53vw] max-lg:h-auto w-[7.71vw] h-[0.97vw] left-1/2 -translate-x-1/2" />
            </div>{" "}
            deployed, and{" "}
            <div className="inline relative z-0">
              <div className="inline relative z-10 font-[600]">
                retention rates 5x{" "}
              </div>{" "}
              <FormatUsersUnderline3 className="absolute bottom-[-5%] z-[-2] max-lg:w-[32.53vw] max-lg:h-auto w-[13.96vw] h-[0.97vw] left-1/2 -translate-x-1/2" />
            </div>{" "}
            higher than mobile apps, the format shows what real engagement looks
            like.
          </motion.p>
        </motion.div>
      </div>

      <div className="absolute left-[0px] rotate-[-5deg] bottom-0">
        <motion.div variants={fadeUpVariants}>
          <LoopLine />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default LandingAbout;
